module.exports = __webpack_public_path__ + "static/media/rc_icon.c495a544.svg";